<template>
  <div class="row">
    <div v-for="(el, index) in element_list.filter((x) => !x.hidden)" :class="el.class" :key="index">

      <div v-if="el.html=='hr'">
        <hr class="mb-n4">
      </div>

      <label class="mt-2" v-if="!(['checkbox', 'button'].includes(el.type))" style="width: 100%">
        {{ el.label }} <span v-if="el.labelRequired === true" class="text-danger">*</span>
      </label>
      <button v-if="el.html == 'button'" v-on:click="buttonFunction(el.onclick)" :type="el.type" :class="el.btnClass">
        {{el.label}}
      </button>
      <div v-if="el.html == 'input'" style="width: 100%">
        <b-input-group v-show="el.security">
          <b-form-input
            :type="el.type"
            v-model="elements[el.model]"
            size="md"
            :placeholder="el.placeholder"
            :disabled="true"
          >
          </b-form-input>

          <b-input-group-prepend @click="change_icon(segment, i, index)">
            <span class="input-group-text">
              <i :class="password_icon ? 'ion ion-md-eye' : 'ion ion-md-eye-off'"></i>
            </span>
          </b-input-group-prepend>
        </b-input-group>

        <input
          v-show="!el.security"
          :type="el.type"
          v-model="elements[el.model]"
          :placeholder="el.placeholder"
          class="form-control"
          :disabled="el.disabled"
        />
      </div>
      <!--ICON SELECT MODAL ELEMENT-->

      <b-form-group v-if="el.html == 'img_div_select' && el.type == 'radio'" style="left: 03rem !important">
        <b-form-radio-group v-model="el.selected" value-field="item" text-field="name">
          <template>
            <div>
              <b-form-radio
                v-for="(option, index) in el.options"
                :key="index"
                :value="option.item"
                class="rounded-pill mx-1 radio-class"
              >
                <div>{{ option.name }}</div>
                <div class="img-div">
                  <div class="row">
                    <div class="col-3" v-for="(img, j) in el.img_list[index]" :key="j">
                      <img :src="img" alt="img" width="125%" height="auto" style="max-height: 55px;max-width: 55px;" />
                    </div>
                  </div>
                </div>
              </b-form-radio>
            </div>
          </template>
        </b-form-radio-group>
      </b-form-group>
      <!-- <v-select
        v-if="el.html == 'select'"
        v-model="elements[el.model]"
        :options="el.options"
        :placeholder="el.placeholder"
        :multiple="el.multiple"
        @input="el.input"
        :clearable="el.clearable"
        :error-messages="selectErrors"
        @change="el['required'] ? $v.elements[el.model].$touch()  : ''"
        @blur="el['required'] ? $v.elements[el.model].$touch()  : ''"
        required
      >
      </v-select> -->
      <multiselect v-if="el.html == 'select' && el['select']" v-model="elements[el.model]" :options="el.options" :multiple="el.multiple" @input="el.input" @select="el.select" @change="el['required'] ? $v.elements[el.model].$touch() : ''"
        @blur="el['required'] ? $v.elements[el.model].$touch() : ''" :allow-empty="(el.clearable ? el.clearable : false)" :placeholder="el.placeholder" :close-on-select="!el.multiple" :clear-on-select="true" :preserve-search="true"
        :label="(el.labelField ? el.labelField : 'label')" track-by="value" :showLabels="false" :limit="2" :limitText="getLimitText" :maxHeight="200" required >
        <span slot="noResult">{{ $t('no_result') }}</span>
        <span slot="noOptions">{{ $t('no_options') }}</span>
      </multiselect>
      <multiselect v-else-if="el.html == 'select'" v-model="elements[el.model]" :options="el.options" :multiple="el.multiple" @input="el.input" @change="el['required'] ? $v.elements[el.model].$touch() : ''"
        @blur="el['required'] ? $v.elements[el.model].$touch() : ''" :allow-empty="(el.clearable ? el.clearable : false)" :placeholder="el.placeholder" :close-on-select="!el.multiple" :clear-on-select="true" :preserve-search="true"
        :label="(el.labelField ? el.labelField : 'label')" track-by="value" :showLabels="false" :limit="2" :limitText="getLimitText" :maxHeight="200" required >
        <span slot="noResult">{{ $t('no_result') }}</span>
        <span slot="noOptions">{{ $t('no_options') }}</span>
      </multiselect>

      <flat-pickr
        v-else-if="el.html == 'date'"
        v-model="elements[el.model]"
        :config="datetimeConfig"
        :placeholder="el.label"
      />

      <template v-if="el['required']">
        <span v-if="!$v.elements[el.model].required" class="text-danger" style="opacity: 0.8">
          {{ errors(el.model) }}
        </span>
      </template>

      <flat-pickr
        v-if="el.html === 'calendar'"
        v-model="elements[el.model]"
        :config="dateConfig"
        :placeholder="el.placeholder"
      />

      <flat-pickr
        v-if="el.html === 'time'"
        v-model="elements[el.model]"
        :config="timeConfig"
        :placeholder="el.placeholder"
      />

      <div v-else-if="el.type == 'checkbox'">
        <b-check v-model="elements[el.model]" class="m-0" style="margin-top: 30px !important" :disabled="el.disabled">
          {{ el.label }}
        </b-check>
      </div>

      <textarea
        v-else-if="el.html == 'textarea'"
        v-model="elements[el.model]"
        class="form-control"
        :placeholder="el.label"
        :disabled="el.disabled"
      />

      <div v-if="el.html == 'show_image' && elements[el.model] && elements[el.model] != ''">
        <a style="cursor: pointer" target="_blank" :href="elements[el.model]">
          <img :src="elements[el.model]" alt="img" width="375" />
        </a>
      </div>

      <b-form-file
        v-if="el.html == 'file'"
        :ref="elements[el.model]"
        :accept="el.accept"
        v-model="elements[el.model]"
        :state="Boolean(elements[el.model])"
        :placeholder="$t('choose_file_or_drop_it_here')"
        :drop-placeholder="$t('drop_the_file_here')"
        @change="changeFile"
        :browse-text="$t('browse')"
      >
      </b-form-file>
    </div>
  </div>
</template>
<script>
import VSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import Api from '@/services/Api';
import { required } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
export default {
  name: 'ModalElements',
  data() {
    return {
      selected: '0',
      dateConfig: {
        time_24hr: false,
        dateFormat: 'j.m.Y',
        enableTime: false,
        altInput: true,
        altFormat: 'j.m.Y',
        locale: this.get_flactpickr_lang(),
      },
      timeConfig: {
        dateFormat: 'H:i',
        altFormat: 'H:i',
        enableTime: true,
        noCalendar: true,
        altInput: true,
        locale: this.get_flactpickr_lang(),
      },
      password_icon: false,
      main_users: [],
    };
  },
  props: {
    element_list: {
      type: Array,
    },
    elements: {
      type: Object,
    },
    datetimeConfig: {
      required: false,
      type: Object,
      default: {
        dateFormat: 'j.m.Y H:i',
        altFormat: 'j.m.Y H:i',
        enableTime: true,
        altInput: true,
      },
    },
  },
  components: {
    flatPickr,
    // VSelect,
    Multiselect,
  },
  validations() {
    let requiredElement = {};
    for (let el in this.element_list) {
      if (this.element_list[el]['required']) {
        requiredElement[this.element_list[el]['required']] = { required };
      }
    }
    return { elements: requiredElement };
  },
  methods: {
    buttonFunction(btnMethod){
      btnMethod()
    },
    getLimitText(count) {
      // $t('vehicles_more', count)
      return `ve ${count} tane daha`;
    },
    get_flactpickr_lang() {
      if (this.$store.getters.lang === 'en') {
        return null;
      } else if (this.$store.getters.lang === 'tr') {
        return Turkish;
      }
    },
    errors(modal) {
      const errors = [];
      !this.$v.elements[modal].required && errors.push(this.$t('required_field'));
      return errors[0];
    },
    elementListFilter(elementList) {
      return elementList.filter(el => el.type === 'button');
    },
    emit_function(click) {
      this.$emit(click, this.elements);
    },
    change_icon(segment, segmentIndex, elementIndex) {
      this.password_icon = !this.password_icon;
      if (this.password_icon) {
        segment['elements'][elementIndex]['type'] = 'text';
      } else {
        segment['elements'][elementIndex]['type'] = 'password';
      }
    },
    changeFile(e) {
      console.log(e);
    },
  },
  mounted() {},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.img-div {
  margin-left: -0.5rem;
  margin-top: 0.5rem;
  border-color: black;
  border-radius: 8px;
  border: 5px solid rgba(144, 7, 15, 0.04);
  width: 15rem;
}

.html:not([dir='rtl']) .mr-1,
html:not([dir='rtl']) .mx-1 {
  margin-left: -1.25rem !important;
}

.radio-class {
  left: 1.2rem;
}

.brand-btn {
    display: inline-block;
    height: 42px;
    width: inherit;
    max-height: 42px;
    margin-top: 37px;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    border-color: transparent;
    background: #02BC77;
    color: #fff;
    font-size: 17px;
    line-height: 1.5;
    border-radius: 0.25rem;

}
.brand-btn:hover {
    display: inline-block;
    height: 42px;
    width: inherit;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    background: #008554;
    color: #fff;
    font-size: 17px;
    line-height: 1.5;
    border-radius: 0.25rem;
    border-color: #008554;
}
</style>
